import React from 'react';

import {
  GRADE_TAB,
  GRADE_TAB_INTERCOM_TARGET,
  MISCONCEPTIONS_TAB,
  MISCONCEPTIONS_TAB_INTERCOM_TARGET,
  OVERALL_RESPONSE_TAB,
  OVERALL_RESPONSE_TAB_INTERCOM_TARGET
} from 'pages/Teachers/Insights/constants';
import { colors } from 'theme/palette';

import Typography from 'components/Typography';

import styles from './styles.module.scss';

const TabSwitcher = ({ activeTab, onTabSwitch }) => {
  const setClassName = (currentTab) => {
    return `${styles.tab} ${activeTab === currentTab ? styles.active : ''}`;
  };

  return (
    <div className={styles.container}>
      <Typography variant="H-TEXT-1" color={colors.pink}>
        What would you like to focus on today?
      </Typography>
      <div className={styles.tabContainer}>
        <div
          className={setClassName(OVERALL_RESPONSE_TAB)}
          onClick={() => onTabSwitch(OVERALL_RESPONSE_TAB)}
          data-intercom-target={OVERALL_RESPONSE_TAB_INTERCOM_TARGET}
        >
          <Typography variant="H-TEXT-2" className={styles.header}>
            {OVERALL_RESPONSE_TAB}
          </Typography>
        </div>

        <div
          className={setClassName(MISCONCEPTIONS_TAB)}
          onClick={() => onTabSwitch(MISCONCEPTIONS_TAB)}
          data-intercom-target={MISCONCEPTIONS_TAB_INTERCOM_TARGET}
        >
          <Typography variant="H-TEXT-2" className={styles.header}>
            {MISCONCEPTIONS_TAB}
          </Typography>
        </div>

        <div
          className={setClassName(GRADE_TAB)}
          onClick={() => onTabSwitch(GRADE_TAB)}
          data-intercom-target={GRADE_TAB_INTERCOM_TARGET}
        >
          <Typography variant="H-TEXT-2" className={styles.header}>
            {GRADE_TAB}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default TabSwitcher;
